import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

import TimeIcon from '../assets/icons/time-icon.svg'
import ForwardArrow from '../assets/icons/forward-arrow.svg'

export default function ContactFloatingButton() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className='sticky z-[100] flex flex-col justify-center gap-20 py-40  w-fit bottom-0 sm:bottom-40 left-[calc(100%-85px)] md:left-[calc(100%-120px)]'
    >
      <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
        <Link
          to='/contact/qnas/intro'
          className='flex flex-col gap-4 w-60 h-60 sm:w-80 sm:h-80 button_white shadow-sk'
        >
          <img className='w-16 h-16 sm:w-20 sm:h-20' src={TimeIcon} alt='' />
          <p className='text-body3-medium sm:text-body1-medium text-sk-default'>1분 문답</p>
        </Link>
      </motion.div>

      <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
        <Link
          to='contact/inquiry'
          className='flex flex-col gap-2 w-60 h-60 sm:w-80 sm:h-80 button_black shadow-sk'
        >
          <img className='w-16 h-16 sm:w-20 sm:h-20' src={ForwardArrow} alt='' />
          <p className='text-body3-medium sm:text-body1-medium text-sk-white'>문의하기</p>
        </Link>
      </motion.div>
    </motion.div>
  )
}
